<template>
	<div class="meeting-ended">
		<div>
			<div v-if="endreason === 'meeting_ended'">{{ meetingEndedText }}</div>
			<div v-if="endreason === 'meeting_left'">
				{{ $t('meetings_have_left', { UserName: hostName() }) }}
			</div>
			<div>{{ $t('meetings_close_tab') }}</div>
		</div>
	</div>
</template>

<script>
import { getVideoSession } from './data'
export default {
	name: 'meetingended',
	props: {
		endreason: {
			type: String,
			default: 'meeting_ended',
			required: false,
		},
	},

	data() {
		return {
			videosession: null,
		}
	},

	mounted() {
		this.videosession = getVideoSession()
	},

	computed: {
		meetingEndedText() {
			if (this.videosession && this.videosession.endedby) {
				const { fullname } = this.videosession.endedby
				return this.$t('meetings_confirmation_ended_with_name', [fullname])
			} else {
				return this.$t('meetings_has_ended')
			}
		},
	},

	methods: {
		hostName() {
			if (!this.videosession) return this.$t('contacts_contactpicker_noname')
			return this.videosession.host.fullname
		},
	},
}
</script>
<style lang="scss" scoped>
.meeting-ended {
	background-color: black;
	z-index: 5;
	color: white;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	display: flex;
	align-items: center;
	justify-content: center;
}

.meeting-ended > div {
	text-align: center;
	font-family: 'Avenir-Medium';
	font-size: 18px;
}

.meeting-ended > div div:first-child {
	font-family: 'Avenir-Black';
	font-size: 32px;
}
</style>
